import React from "react";
import styles from "./FeatureLockedState.module.scss";
import Button from "../xepp/button/Button";
import { ArrowRight, LockIcon } from "../../../assets/icons";
import { useTenant } from "../../../tenant/branding/useTenant";

const BPS_SUPPORT_EMAIL = "support@bpsafrica.com";

interface FeatureLockedStateProps {
	/** Feature name, used in the activation request. */
	featureName: string;
	/** Replaces the default mailto to the BPS team. */
	onRequestActivation?: () => void;
	className?: string;
}

/**
 * Placeholder shown in place of a page (or a section) whose feature flag is off for
 * the utility. The user can still open the page — they just find this instead of
 * the content. "Request Activation" opens a pre-filled email to the BPS team unless
 * the caller provides its own handler.
 */
const FeatureLockedState: React.FC<FeatureLockedStateProps> = ({
	featureName,
	onRequestActivation,
	className = "",
}) => {
	const { name: utilityName } = useTenant();

	const requestActivation = () => {
		if (onRequestActivation) {
			onRequestActivation();
			return;
		}
		const subject = encodeURIComponent(`Feature activation request: ${featureName}`);
		const body = encodeURIComponent(
			`Hello BPS team,\n\nPlease activate "${featureName}" for ${utilityName}.\n\nThank you.`,
		);
		window.location.href = `mailto:${BPS_SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
	};

	return (
		<div className={`${styles.wrapper} ${className}`}>
			<div className={styles.card}>
				<div className={styles.iconCircle}>
					<LockIcon />
				</div>
				<p className={styles.message}>
					This feature is currently unavailable. Contact the BPS team to request activation.
				</p>
				<Button
					text="Request Activation"
					variant="primary"
					onClick={requestActivation}
					className={styles.button}
					rightIcon={<ArrowRight className={styles.arrow} />}
				/>
			</div>
		</div>
	);
};

export default FeatureLockedState;
